import * as React from "react";
import { render } from "react-dom";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { fetchSubmissionsForKitRegistration, fetchSubmissionStatus } from "../utility";
import { MdError } from 'react-icons/md';
import {FaCheck} from 'react-icons/fa';
import {FaUpload} from 'react-icons/fa';
import ReactDOMServer from 'react-dom/server';




const MdErrorHTML = ReactDOMServer.renderToString(
    <MdError />
)

const FaCheckHTML = ReactDOMServer.renderToString(
    <FaCheck />
)


const faUploadHTML = ReactDOMServer.renderToString(
    <FaUpload className="mx-1" style={{verticalAlign: 'sub'}}/>
)



export default function DataAnalysesTable() {

    const KIT_REGISTRATION_ID = window.location.pathname.split("/")[2];
    const PENDING_STATES = ["Submitted", "Queued", "Profiling", "Preprocessing"];

    const [pendingSubmissions, setPendingSubmissions] = React.useState([]);
    

    document.getElementById('add-data-files-btn-kr').innerHTML = faUploadHTML + " Add Data Files";
    React.useEffect(() => {
        
        fetchSubmissionsForKitRegistration(KIT_REGISTRATION_ID)
        .then((data) => {
            console.log(data)
            renderTable(data, "data-analyses-table");
            data.map((submission) => {
                PENDING_STATES.includes(submission.status) && setPendingSubmissions((prev) => [...prev, submission])
            })
        })


    }, []);

    React.useEffect(() => {
        console.log("Pending submissions:", pendingSubmissions)
        if (pendingSubmissions.length > 0) {
            console.log("Checking for pending submissions...", pendingSubmissions)
            // let interval = setInterval(() => {
            //     console.log("Checking for pending submissions...")
            //     fetchSubmissionStatus(pendingSubmissions[0].id)
            //     .then((data) => {
            //         console.log(data)
            //         if (!PENDING_STATES.includes(data.status)) {
            //             console.log("Submission is no longer pending.")
            //             setPendingSubmissions((prev) => prev.slice(1));
            //             clearInterval(interval);
            //         }
            //     })
            // }, 5000);
        }
    }, [pendingSubmissions]);

    return (
        <div>
            {/* <div className="d-flex justify-content-between">
                <h1>Data Analyses:</h1>
                <button className="btn btn-lg btn-dark m-1 h-100 shadow-sm" onClick={() => window.location.href = `/submissions/new?kit_registration_id=${KIT_REGISTRATION_ID}`}>+ Add Data Files</button>
            </div> */}
            <div className="table-light" id="data-analyses-table" />
        </div>
    )

}



function renderTable(data, divId) {
    let tableEle = document.getElementById(divId);
    let table = new Tabulator(tableEle, {
        // height:"100%",
        responsiveLayout:"collapse",
        renderVertical:"basic",
        layout:"fitColumns",
        data: data,
        pagination: true,
        paginationSize: 10,
        columns:[
            {title:"ID", field:"id", width: 50, sorter:"number", visible: true, vertAlign:"middle", hozAlign:"center", responsive: true, cssClass:"kit-name-column"},
            {title:"Name", field:"name", sorter:"string", visible: true, vertAlign:"middle", responsive: true, cssClass:"kit-name-column"},
            {title:"Date Created", field:"created_at", sorter:"date", visible: true, vertAlign:"middle", hozAlign:"center", responsive: true, cssClass:"kit-name-column"},
            {title:"Last Updated", field:"updated_at", sorter:"date", visible: true, vertAlign:"middle", hozAlign:"center", responsive: true, cssClass:"kit-name-column"},
            {title:"Panel", field:"panel", sorter:"string", visible: true, vertAlign:"middle", hozAlign:"center", responsive: true, cssClass:"kit-name-column"},
            {title:"Smart Peak Picking", field:"use_smart_peak_picking", sorter:"boolean", visible: true, vertAlign:"middle", hozAlign:"center", responsive: true, cssClass:"kit-name-column", formatter: "tickCross"},
            {title:"Last Action Params", field:"last_action_params", sorter:"boolean", visible: true, vertAlign:"middle", hozAlign:"center", responsive: true, cssClass:"kit-name-column", formatter: function(cell, formatterParams, onRendered) {
                let params = cell.getValue();
                return params ? JSON.stringify(params) : ""
            }},
            
            {
                title:"Status", 
                field:"status", 
                sorter:"string",
                width: 200, 
                visible: true, 
                vertAlign:"middle", 
                responsive: true,
                cssClass:"kit-name-column",
                formatter: function(cell, formatterParams, onRendered) {
                    let status = cell.getValue();
                    // let status = "Profiling"
                    return `
                    <span class='d-flex justify-content-between mx-2 gap-1 w-100'>
                    <span>${status} </span>
                    ${status === "Submitted" ? "<div class='spinner-grow spinner-grow-sm text-success align-self-center' />" : ""}
                    ${status === "Queued" ? "<div class='spinner-grow spinner-grow-sm text-warning align-self-center' />" : ""}
                    ${status === "Profiling" || status == "Preprocessing" ? "<div class='spinner-border spinner-border-sm text-secondary align-self-center' />" : ""}
                    ${status === "Profiled" || status == "Preprocessed" ? `<div class='d-inline-block align-baseline text-success'><span>${FaCheckHTML}</span></div>` : ""}
                    ${status === "Errored" ? `<div class='d-inline-block align-baseline text-danger'><span>${MdErrorHTML}</span></div>` : ""}
                    </span>
                    `
                }
            },
            {
                title:"Profiling Duration (s)",
                field:"profiling_duration",
                sorter:"number",
                visible: true,
                vertAlign:"middle",
                hozAlign:"center",
                responsive: true,
                cssClass:"kit-name-column",
                // formatter: function(cell, formatterParams, onRendered) {
                    //     return cell.getValue() ? (cell.getValue() / 60).toFixed(2) : ""
                    // }
            },
            {
                title:"Total Run Time (s)",
                field:"runtime",
                sorter:"number",
                visible: true,
                vertAlign:"middle",
                hozAlign:"center",
                responsive: true,
                cssClass:"kit-name-column",
            },
            {
                title: "Number of Experimental Samples",
                field: "num_exp_samples",
                sorter: "number",
                visible: true,
                vertAlign: "middle",
                hozAlign: "center",
                responsive: true,
                cssClass: "kit-name-column",
            },
            {
                title:"Actions",
                formatter:submissionActionButtons,
                hozAlign:"center",
                responsive: true,
                cssClass:"kit-name-column",
                // width: 300,
            },
            {title:"Error Message", field:"error_msg", sorter:"string", visible: true, vertAlign:"middle", responsive: true, cssClass:"kit-name-column"},
        ],
    });
    return table;



}


let submissionActionButtons = function(cell, formatterParams, onRendered) {

    let viewSubmissionHref = window.location.origin + "/submissions/" + cell.getRow().getData().id + "/analytes/" + cell.getRow().getData().last_action_params?.analyte_id?.toString() + "?tab=chromatograms";
    let html = `
        <a href="${viewSubmissionHref}" class="w-100">
            <button class="btn btn-dark btn-outline-light w-100">
                View
            </button>
        </a>
    `
    return html;
}